import { useState } from 'react';

interface UseCustomPaginationProps {
  filteredResults?: unknown[];
  rowsPerPage?: number;
}

export const useCustomPagination = ({ filteredResults, rowsPerPage = 5 }: UseCustomPaginationProps) => {
  const maxPages = Math.ceil(filteredResults?.length / rowsPerPage);
  const [page, setPage] = useState(1);
  const onNext = () => {
    if (page === maxPages) return;
    setPage(page + 1);
  };
  const onPrev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };
  const disablePrev = page === 1;
  const disableNext = page === maxPages;

  const itemsLength = filteredResults?.length;

  return { page, setPage, maxPages, rowsPerPage, onNext, onPrev, disableNext, disablePrev, itemsLength };
};
